import React, {useEffect} from "react"
import {useNavigate} from "react-router-dom"
import {useAuth} from "../context"

export default function Check() {
    let auth = useAuth()
    let navigate = useNavigate()

    useEffect(() => {
        if (auth.loaded) {
            if (!auth.user) {
                // @ts-ignore
                window.location = "/login"
            } else
                navigate("/")
        }
    }, [auth.loaded])

    return <div>checking...</div>

}

